export const normalizePathname = (pathname: string) =>
  pathname.replace(/^\/|\/$/g, "");
